import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { validateEmail } from "utils";
import qrcode from "assets/images/qrcode.png";

// import { Avatar } from "@mui/material";
import { toast } from "react-hot-toast";
// import TeacherForm from "./Sections/AddStaff/TeacherForm";
// import EvaluatorForm from "./Sections/AddStaff/EvaluatorForm";
import { Input, Select, TextArea } from "components/Form/index";
import { Button } from "components/Button/Button";
// import ReactSelect from "react-select";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";
// import { getUserTypes ,getDepartmentType,getSingleRegionStatebyid,getRegionStatesList,getTalukaListbyid} from "services/master";
// import VideoEditorForm from "./Sections/AddStaff/VideoEditorForm";
// import { addStaff } from "services/staff/staffController";
// import { encryptData } from "config/config";
// import useCookie from "hooks/useCookie";
// import { EditorState } from "draft-js";
import {
  addUser,
  getDistrictdropdownList,
  getStatedropdownList,
  getTalukadropdownList,
  getUserRoledropdownList,
} from "services/usermanagement";
import { addDonation } from "services/donationmanagement/donationindex";
import useFullPageLoader from "hooks/useFullPageLoader";
// import { getDistrictList } from "services/statemanagement";
// import ModeratorForm from "./Sections/AddStaff/ModeratorForm";
// import AffiliateAdmin from "./Sections/AddStaff/AffiliateAdmin";

export default function AddNewDonation() {
  const navigate = useNavigate();
  // const { cookies } = useCookie();

  const [isValidEmail, setIsValidEmail] = useState(true);
  const [mobError, setMobError] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  // const [allUserType, setAllUserType] = useState([]);
  const [staffData, setStaffData] = useState({
    name: "",
    mobile: "",
    amount: "",
    donationtype: "",
    paymentmode: "",
    // userName: "",
  });

  const [errorField, setErrorField] = useState({
    name: "",
    mobile: "",
    amount: "",
    donationtype: "",
    paymentmode: "",
  });

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    // if (!profileImage) {
    //   errorField["profile"] = "Please Select Profile";
    //   formIsValid = false;
    // }
    if (!staffData.name) {
      errorField["name"] = "Please Enter Name";
      formIsValid = false;
    }

    if (!staffData.mobile) {
      errorField["mobile"] = "Please Enter Mobile No.";
      formIsValid = false;
    } else if (staffData.mobile.length !== 10) {
      errorField["mobiles"] = "Mobile number must be 10 digits";
      formIsValid = false;
    }
    //  else if (staffData.mobile.length !== 10) {
    //   errorField["mobiles"] = "Mobile number must be 10 digits";
    //   formIsValid = false;
    // }
    if (!staffData.amount) {
      errorField["amount"] = "Please Enter Amount";
      formIsValid = false;
    }
    if (!staffData.donationtype) {
      errorField["donationtype"] = "Please Enter Donation Type";
      formIsValid = false;
    }
    if (!staffData.paymentmode) {
      errorField["paymentmode"] = "Please Enter Payment Mode";
      formIsValid = false;
    }

    if (!staffData.panNumber) {
      errorField["panNumber"] = "Please Enter PAN Number";
      formIsValid = false;
    }else if (staffData.panNumber.toString().length != 12) {
      errorField["panNumber2"] = "PAN number must be 12 digits";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };
  //*********************Submit Staff Handler********************************** *//
  const submitStaff = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const res = await addDonation({
          Name: staffData.name,
          Mobile: staffData.mobile,
          PaymentMode: staffData.paymentmode,
          PaymentType: "Offline",
          Amount: staffData.amount,
          DonationType: staffData.donationtype,
          PanNumber: staffData.panNumber.toUpperCase(),
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  const [showQRCode, setShowQRCode] = useState(false); // New state for QR Code visibility

  // Handle Input Changes
  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    if (name === "paymentmode") {
      setShowQRCode(value === "QR Code"); // Show QR code if "QR Code" is selected
    }

    setStaffData({ ...staffData, [name]: value });
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5 d-flex justify-content-between">
                <h4 className="Title">
                  <Link to={-1}>
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  Add New Donation
                </h4>
              </div>
            </div>
            {loader}
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitStaff}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="name"
                                value={staffData.name}
                                onChange={onChangeHandler}
                                placeholder="Enter Name"
                                className={`form-control `}
                                maxLength={30}
                                label="Name"
                                error={errorField.name}
                                required
                              />
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="mobile"
                                value={staffData.mobile}
                                onChange={(e)=>{
                                    const {name,value} = e.target;
                                    setStaffData({...staffData,[name]:value.replace(/\D/g, "")})
                                }}
                                maxLength={10}
                                placeholder="Enter Mobile"
                                className={`form-control ${mobError && "is-invalid"}`}
                                label={"Mobile"}
                                error={errorField.mobile}
                                required
                              />
                              {errorField.mobiles && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.mobiles}
                                </span>
                              )}
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="panNumber"
                                value={staffData.panNumber}
                                onChange={(e)=>{
                                    const {name,value} = e.target;
                                    setStaffData({...staffData,[name]:value.toUpperCase()})
                                }}
                                maxLength={12}
                                placeholder="Enter PAN Number"
                                className={`form-control `}
                                label={"PAN Number"}
                                error={errorField.panNumber}
                                required
                              />
                              {errorField.panNumber2 && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.panNumber2}
                                </span>
                              )}
                            </div>

                            {/* </div>
                                                </div>


                                                <div className="col-md-12">
                                                    <div className="row"> */}
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="amount"
                                value={staffData.amount}
                                onChange={onChangeHandler}
                                placeholder="Enter Amount"
                                className="form-control"
                                maxLength={30}
                                label="Amount"
                                error={errorField.amount}
                                required
                              />
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Select
                                name="paymentmode"
                                placeholder="Select"
                                onChange={onChangeHandler}
                                value={staffData.paymentmode}
                                className={`form-control `}
                                error={errorField.paymentmode}
                                label={"Payment Mode"}
                                required
                              >
                                <option value="">Select </option>
                                {[
                                  { value: "Cash", name: "Cash" },
                                  { value: "QR Code", name: "QR Code" },
                                ].map(({ value, name }) => {
                                  return (
                                    <option value={value} key={value}>
                                      {name}
                                    </option>
                                  );
                                })}
                              </Select>
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Select
                                name="donationtype"
                                placeholder="Select"
                                onChange={onChangeHandler}
                                value={staffData.donationtype}
                                className={`form-control `}
                                error={errorField.donationtype}
                                label={"Donation Type"}
                                required
                              >
                                <option value="">Select </option>
                                {[
                                  { value: "AnnaDaan", name: "AnnaDaan" },
                                  {
                                    value: "PranpratishSthapana",
                                    name: "PranpratishSthapana",
                                  },
                                ].map(({ value, name }) => {
                                  return (
                                    <option value={value} key={value}>
                                      {name}
                                    </option>
                                  );
                                })}
                              </Select>
                            </div>

                            {/* </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="row"> */}

                            {showQRCode && (
                              <div className="col-md-6 text-center mt-3">
                                <img
                                  src={qrcode}
                                  alt="QR Code"
                                  style={{ width: "200px", height: "200px" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <Button type="submit" {...submitButtonElement}>
                      Add Donation
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
